<template>
  <div>
    <app-cells>
      <h1 class="title">Safari groups</h1>
    </app-cells>
    <app-tabs :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view  />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'SafariGroupsLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'safari-groups', label: 'Upcoming' },
        { name: 'safari-groups-tour', label: 'In tour' },
        { name: 'safari-groups-archive', label: 'Archive' },
        { name: 'safari-groups-cancelled', label: 'Cancelled', roles: ['general_manager', 'support', 'finance_manager', 'accountant_manager', 'accountant_supervisor', 'sales_manager', 'sales_supervisor', 'safari_supervisor', 'safari_manager', 'safari_assistant', 'operations_manager', 'operations_supervisor'] },
      ],
    }
  },
}
</script>
